import { http } from './http';

export function getReviews(category, id) {
  return http.get(`/api/v1/media/${category}/${id}/reviews`).then((r) => r.data);
}

export function createReview(category, id, payload) {
  return http.post(`/api/v1/media/${category}/${id}/reviews`, payload).then((r) => r.data);
}
